import { Button, Card, Col, Row } from 'antd'
import React, { useEffect } from 'react'
import { AreaChartOutlined } from '@ant-design/icons'
import AOS from 'aos';
import 'aos/dist/aos.css'
import './ServiceOffered.scss';
import aua1 from '../../assets/images/OTP_Auth_New.png'
import aua2 from '../../assets/images/Demo_Auth_2.jpg'
import aua3 from '../../assets/images/Bio_AuthChat.png'
import aua4 from '../../assets/images/kyc_image.jpeg'
import service_left from '../../assets/images/servicesoffered_left.png'
import service_right from '../../assets/images/servicesoffered_right.png'
import { ArrowRightOutlined, MenuOutlined } from '@ant-design/icons';

function ServiceOffered() {
    const [activetab, setActivetab] = React.useState('AUA');
    const [activeBtn, setActiveBtn] = React.useState(0);
    const carouselRef = React.useRef<HTMLDivElement>(null);
    const [isActive, setIsActive] = React.useState(Array(4).fill(false));
    const slideRefs = React.useRef<HTMLDivElement[]>([]);
    useEffect(() => {
        AOS.init({  
            duration: 1000,
        });
    }, [])

    const handleEnter = (index: number): void => {
  setIsActive(prev => {
    const newState = [...prev];
    newState[index] = true;
    return newState;
  });
};

const handleLeave = (index: number): void => {
  setIsActive(prev => {
    const newState = [...prev];
    newState[index] = false;
    return newState;
  });
};

    const tabs = [
        "Authentication Service",
        "e-KYC Service",
        "Biometric Authentication",
        "Auth with (OTP)",
    ];

    const asaServices = [
        {
            id: 1,
            img: aua1,
            title: 'ASA Gateway Connectivity',
            description: 'Secure leased-line connectivity and gateway to UIDAI CIDR for AUAs and other entities.'
        },
        {
            id: 2,
            img: aua2,
            title: 'Request Relay & Routing',
            description: 'Reliable routing and forwarding of authentication/e-KYC requests from AUAs to CIDR and back.'
        },
        {
            id: 3,
            img: aua3,
            title: 'e-KYC Response Relay',
            description: 'Safely relay e-KYC responses and attribute data while ensuring privacy and integrity.'
        },
        {
            id: 4,
            img: aua4,
            title: 'Monitoring, Logging & Compliance',
            description: 'End-to-end logging, audit trails, SLA monitoring and compliance for UIDAI interactions.'
        },
    ];


    const goToSlide = (index: any) => {
        const slide = slideRefs.current[index];
        const container = carouselRef.current;
        if (!slide || !container) return;

        //   container.scrollTo({
        //     top: slide.offsetTop,
        //     behavior: "smooth"
        //   });
        // Scroll only the container
        container.scrollTop = slide.offsetTop - container.offsetTop;
        // slide.scrollIntoView({ behavior: "smooth", block: "start" });

        setActiveBtn(index);
    };
    useEffect(() => {
        const container = carouselRef.current;
        if (!container) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const index = Number(entry.target.getAttribute("data-index"));
                        setActiveBtn(index);
                    }
                });
            },
            {
                root: container,       // <= IMPORTANT: observe inside scrollable div
                threshold: 0.5         // 50% visibility
            }
        );

        slideRefs.current.forEach((slide) => {
            if (slide) observer.observe(slide);
        });

        return () => observer.disconnect();
    }, []);
    return (
        <section id="serviceoffered" className="serviceBlock" style={{ scrollMarginTop: '70px' }}>
            <img src={service_left} alt='image' className="corner bottom-left" />
            <img src={service_right} alt='image' className="corner top-right" />

            <div className="container-fluid">
                <div className="titleHolder">
                    {/* <h2 data-aos="fade-up">Authentication Services <span className="title-accent">Offered</span></h2> */}
                    <h2 data-aos="fade-up" style={{margin: '0px', }}>Services <span className="title-accent">Offered</span></h2>
                    <p data-aos="fade-up" data-aos-delay="100" style={{margin: '0px'}}>
                        Aadhaar Authentication & e-KYC Services
                    </p>
                </div>
                    <Row gutter={[16, 16]} style={{ marginTop: '36px' }}>
                        <Col xs={24} sm={12} md={12} lg={6} xl={6} data-aos="fade-up" data-aos-delay="200">
                            <div className='aua-service-div'>
                            <div className="image-wrapper"
                                onMouseEnter={() => handleEnter(0)}
                                onMouseLeave={() => handleLeave(0)}
                            >
                                <img
                                    className='uniform-image'
                                    loading='lazy'
                                    src={aua1}
                                    alt="OTP Authentication"
                                />
                            </div>
                            <h3 className="image-caption">OTP Auth</h3>
                            <div className="text-described">
                                <p>Provides OTP-based verification by sending a one-time password to the user's registered mobile number for authentication.</p>
                            </div>
                            </div>
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={6} xl={6} data-aos="fade-up" data-aos-delay="300" >
                        <div className='aua-service-div'>
                            <div className="image-wrapper"
                                onMouseEnter={() => handleEnter(1)}
                                onMouseLeave={() => handleLeave(1)}
                            >
                                <img
                                    className='uniform-image'
                                    loading='lazy'
                                    src={aua2}
                                    alt="Demographic Authentication"
                                />

                            </div>
                            <div>
                                <h3 className="image-caption">Demographic Auth</h3>
                                <div className="text-described">
                                    <p>Enables verification of user identity using demographic details such as name, address, and date of birth stored in the CIDR database.</p>
                                </div>
                            </div>
                            </div>
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={6} xl={6} data-aos="fade-up" data-aos-delay="400">
                            <div className='aua-service-div'>
                                <div className="image-wrapper"
                                    onMouseEnter={() => handleEnter(2)}
                                    onMouseLeave={() => handleLeave(2)}
                                >
                                    <img
                                        className='uniform-image'
                                        loading='lazy'
                                        src={aua3}
                                        alt="Biometric Authentication"
                                    />
                                </div>
                                <h3 className="image-caption">Biometric Auth</h3>
                                <div className="text-described">
                                    <p>Allows verification of user identity using biometric data such as fingerprints, face or iris scans stored in the CIDR database.</p>
                                </div>
                            </div>
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={6} xl={6} data-aos="fade-up" data-aos-delay="500">
                            <div className='aua-service-div'>
                                <div className="image-wrapper"
                                    onMouseEnter={() => handleEnter(3)}
                                    onMouseLeave={() => handleLeave(3)}
                                >
                                    <img
                                    className='uniform-image'
                                    loading='lazy'
                                    src={aua4}
                                    alt="KYC Service"
                                />
                            </div>
                            <h3 className="image-caption">e-KYC</h3>
                            <div className="text-described">
                                <p>Provides e-KYC (Know Your Customer) services for identity verification and compliance with regulatory requirements.</p>
                            </div>
                            </div>
                        </Col>
                    </Row>

            </div>
        </section>
    )
}

export default ServiceOffered
